import kountSDK from "@kount/kount-web-client-sdk";
import { QueryFunctionContext } from "@tanstack/react-query";
import jwtDecode from "jwt-decode";

import { logger } from "c7-logger";

type JwtProps = {
  ksi: string;
};

export type InitKount = {
  checkoutSessionToken: string;
  safetechMerchantId: string;
  kountSessionHostname: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const queryKeys = {
  initKount: (params: InitKount) =>
    [{ scope: "init-kount", ...params }] as const,
};

export function initKount({
  queryKey: [
    { checkoutSessionToken, safetechMerchantId, kountSessionHostname },
  ],
}: QueryFunctionContext<ReturnType<(typeof queryKeys)["initKount"]>>): boolean {
  return initializeKount({
    checkoutSessionToken,
    safetechMerchantId,
    kountSessionHostname,
  });
}

export const initializeKount = ({
  checkoutSessionToken,
  safetechMerchantId,
  kountSessionHostname,
}: InitKount): boolean => {
  // get Merchant ID and orderId
  // it will error if not a JWT
  if (safetechMerchantId && checkoutSessionToken) {
    const { ksi }: JwtProps = jwtDecode(checkoutSessionToken);
    if (ksi) {
      const hostname = kountSessionHostname || "";
      const config = {
        clientID: parseInt(safetechMerchantId),
        isSinglePageApp: true,
        hostname,
      };

      const initialized = kountSDK(config, ksi);
      if (typeof initialized === "undefined") {
        return false;
      }

      // More features could be built off of this value, for now
      // we just pass a boolean
      // If init is valid sessionID will be echoed
      return !!initialized && !!initialized.sessionID;
    }
    logger.error("Invalid JWT values");
    return false;
  }
  return false;
};
